import React, { Component } from "react";
import MapPageItemsByVendor from '../components/MapPageItemsByVendor';
import "./home.css";

export default class Home extends Component {

  render() {
    return (
      <div>
        <MapPageItemsByVendor />
      </div>
    );
  }
}
